import axios from '@/http/axios';

export default {
  fetchAllTimezones: () => {
    return axios.get(`/system-data/timezones/all`);
  },
};
